/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';


function SEO(props) {
  const { lang, meta, title, description, siteName, url, keywords } = props;

  const metaTitle = title || 'Push payments simplified | Checkbook';
  const metaDescription = description || 'Our all-in-one push payments platform offers everything you need to disburse payments at scale. No hassle. No percentages. No hidden fees.';
  const metaSiteName = siteName || 'Checkbook';
  const metaKeywords = keywords || 'payments, ach, virtual card, rtp, oct, push to card, Digital Checks, echecks, e-checks';
  const metaUrl = url || 'https://checkbook.io';

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={metaTitle}
      meta={[
        {
          name: 'image',
          content: `${metaUrl}/img/og-image.png`,
        },
        {
          name: 'description',
          content: metaDescription,
        },
        {
          name: 'keywords',
          content: metaKeywords,
        },
        {
          property: 'og:title',
          content: metaTitle,
        },
        {
          property: 'og:description',
          content: metaDescription,
        },
        {
          property: 'og:site_name',
          content: metaSiteName,
        },
        {
          property: 'og:image',
          content: `${metaUrl}/img/og-image.png`,
        },
        {
          property: 'og:url',
          content: metaUrl,
        },
        {
          property: 'og:type',
          content: 'website',
        },
        {
          name: 'twitter:card',
          content: 'summary_large_image',
        },
        {
          name: 'twitter:title',
          content: metaTitle,
        },
        {
          name: 'twitter:description',
          content: metaDescription,
        },
        {
          property: 'twitter:image',
          content: `${metaUrl}/img/og-image.png`,
        },
      ].concat(meta)}
    />
  );
}

SEO.propTypes = {
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string,
  description: PropTypes.string,
  siteName: PropTypes.string,
  url: PropTypes.string,
  keywords: PropTypes.string,
};

SEO.defaultProps = {
  lang: 'en',
  meta: [],
  title: '',
  description: '',
  siteName: '',
  url: '',
  keywords: '',
};

export default SEO;
